import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

function DetailRdv() {
  const { appointmentId } = useParams();
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!appointmentId) return;

    fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/appointments/${appointmentId}`)
      .then(res => res.json())
      .then(data => {
        setAppointment(data);
        return fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/appointments/${appointmentId}/notes`);
      })
      .then(res => res.json())
      .then(notesData => {
        setNotes(notesData);
        setLoading(false);
      })
      .catch(err => {
        console.error('Erreur chargement détail RDV :', err);
        setLoading(false);
      });
  }, [appointmentId]);

  const handleAddNote = async () => {
    if (!newNote.trim()) return;
    try {
      const res = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/records/${appointment.record_id}/notes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          content: newNote,
          author_id: localStorage.getItem('user_id'),
          appointment_id: appointment.appointment_id
        })
      });

      if (res.ok) {
        const note = await res.json();
        setNotes(prev => [note, ...prev]);
        setNewNote('');
      }
    } catch (err) {
      console.error('Erreur ajout note :', err);
    }
  };

  if (loading) return <p>Chargement...</p>;
  if (!appointment) return <p>Rendez-vous introuvable.</p>;

  return (
    <div style={{ padding: '20px' }}>
      <h2>Détail du rendez-vous</h2>
      <p><strong>Date :</strong> {format(new Date(appointment.start_time), "eeee dd MMMM yyyy 'à' HH:mm", { locale: fr })}</p>
      <p><strong>Avec :</strong> Dr. {appointment.professional_first_name} {appointment.professional_last_name}</p>
      <p><strong>Service :</strong> {appointment.service_name}</p>
      <p><strong>Statut :</strong> {appointment.status}</p>

      <h3>Notes associées</h3>
      {notes.length > 0 ? (
        <ul>
          {notes.map(note => (
            <li key={note.note_id}>
              {format(new Date(note.created_at), "dd/MM/yyyy HH:mm", { locale: fr })} — {note.author_first_name} {note.author_last_name} :<br />
              <em>{note.content}</em>
            </li>
          ))}
        </ul>
      ) : (
        <p><em>Aucune note disponible.</em></p>
      )}

      <h3>Ajouter une note</h3>
      <textarea value={newNote} onChange={(e) => setNewNote(e.target.value)} rows={4} style={{ width: '100%' }} />
      <br />
      <button onClick={handleAddNote}>Ajouter la note</button>

      <br /><br />
      <button onClick={() => navigate(-1)}>Retour</button>
    </div>
  );
}

export default DetailRdv;